/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.unitModule')

.service('BulbSubCollectionService', ['BulbUnitService', 'CONFIG', BulbSubCollectionService]);

function BulbSubCollectionService(BulbUnitService, CONFIG) {

  var subCollectionMaxCount = parseInt(CONFIG.subcollection.max.count, 10);

  var getCollectionNestedCount = function() {
    var nestedCount = 0;
    var ancestorUnits = BulbUnitService.currentUnit.ancestorUnits.concat(BulbUnitService.currentUnit);
    angular.forEach(ancestorUnits, function(unit) {
      if (unit.unitType === 'CompositeUnit') {
        nestedCount += 1;
      }
    });
    return nestedCount;
  };

  // subcollection create limit check
  this.isSubCollectionCountUnderLimit = function() {
    return subCollectionMaxCount === -1 || getCollectionNestedCount() < subCollectionMaxCount;
  };

  this.canDropCollectionIntoSubCollection = function() {
    return subCollectionMaxCount === -1 || getCollectionNestedCount() < subCollectionMaxCount - 1;
  };

}

